var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c(
        "div",
        [
          _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                { staticClass: "is-flex is-align-content-center" },
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { placeholder: "Period" },
                          model: {
                            value: _vm.selectedDuration,
                            callback: function ($$v) {
                              _vm.selectedDuration = $$v
                            },
                            expression: "selectedDuration",
                          },
                        },
                        _vm._l(_vm.duration, function (option) {
                          return _c(
                            "option",
                            { key: option.id, domProps: { value: option.id } },
                            [_vm._v(" " + _vm._s(option.text) + " ")]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { "icon-left": "calendar-alt" },
                      on: { click: _vm.generateBarcodes },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("pages.loads.planning")) + " ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("b-loading", {
            attrs: { "is-full-page": false },
            model: {
              value: _vm.isLoading,
              callback: function ($$v) {
                _vm.isLoading = $$v
              },
              expression: "isLoading",
            },
          }),
          _c(
            "div",
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-alpine",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  "row-data": _vm.shipments,
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "animate-rows": true,
                  "row-selection": "multiple",
                  "pagination-auto-page-size": true,
                  "get-context-menu-items": _vm.getContextMenuItems,
                  "group-selects-children": true,
                  "group-selects-filtered": true,
                  "detail-row-height": 200,
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                },
                on: { "grid-ready": _vm.gridReady },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isMaterialModalActive,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isMaterialModalActive = $event
            },
          },
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.materials")) + " "),
              ]),
            ]),
            _c(
              "section",
              { staticClass: "modal-card-body" },
              [
                _c(
                  "b-field",
                  { attrs: { grouped: "" } },
                  [
                    _c(
                      "b-field",
                      [
                        _c("b-input", {
                          attrs: {
                            placeholder: "Search...",
                            type: "search",
                            icon: "search",
                          },
                          model: {
                            value: _vm.searchMaterial,
                            callback: function ($$v) {
                              _vm.searchMaterial = $$v
                            },
                            expression: "searchMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "is-info", "icon-left": "file-csv" },
                            on: { click: _vm.exportMaterials },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.export")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-table",
                  {
                    attrs: {
                      "per-page": 15,
                      data: _vm.filteredMaterials,
                      loading: _vm.isLoading,
                      narrowed: "",
                      striped: "",
                      paginated: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (props) {
                          return [
                            _c("span", [_vm._v(_vm._s(props.column.label))]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("b-table-column", {
                      attrs: {
                        field: "barcode",
                        label: "Barcode",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.barcode) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: {
                        field: "material",
                        label: "Material",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.material) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: {
                        field: "scannedAt",
                        label: "Scanned at",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    new Date(
                                      props.row.scannedAt
                                    ).toLocaleString()
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("template", { slot: "bottom-left" }, [
                      _c("b", [
                        _vm._v(" " + _vm._s(_vm.$t("global.total")) + " "),
                      ]),
                      _vm._v(": " + _vm._s(_vm.filteredMaterials.length) + " "),
                    ]),
                    _c("template", { slot: "empty" }, [_c("nothing-here")], 1),
                  ],
                  2
                ),
              ],
              1
            ),
            _c("footer", { staticClass: "modal-card-foot" }),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isAttachModalActive,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isAttachModalActive = $event
            },
            close: _vm.resetAttachForm,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-card",
              staticStyle: { "min-height": "630px" },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("global.materials")) + " "),
                ]),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _c(
                  "form",
                  {
                    attrs: { id: "attachForm" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submitAttachForm.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: _vm.$t("pages.loads.receipt_date") } },
                      [
                        _c("b-datetimepicker", {
                          attrs: {
                            placeholder: "Click to select...",
                            icon: "calendar",
                            "max-datetime": _vm.maxDatetime,
                            "min-datetime": _vm.minDatetime,
                            required: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "left",
                              fn: function () {
                                return [
                                  _c("b-button", {
                                    attrs: {
                                      label: "Now",
                                      type: "is-primary",
                                      "icon-left": "clock",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.attachForm.dateField = new Date()
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.attachForm.dateField,
                            callback: function ($$v) {
                              _vm.$set(_vm.attachForm, "dateField", $$v)
                            },
                            expression: "attachForm.dateField",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: _vm.$t("pages.loads.separator") } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { required: "" },
                            on: { input: _vm.processFile },
                            model: {
                              value: _vm.attachForm.separator,
                              callback: function ($$v) {
                                _vm.$set(_vm.attachForm, "separator", $$v)
                              },
                              expression: "attachForm.separator",
                            },
                          },
                          [
                            _c("option", { attrs: { value: "newline" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.loads.new_line")) +
                                  " "
                              ),
                            ]),
                            _c("option", { attrs: { value: "semicolon" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.loads.semicolon")) +
                                  " "
                              ),
                            ]),
                            _c("option", { attrs: { value: "comma" } }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("pages.loads.comma")) + " "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: _vm.$t("pages.loads.process") } },
                      [
                        _c(
                          "b-checkbox",
                          {
                            model: {
                              value: _vm.attachForm.ignoreProcess,
                              callback: function ($$v) {
                                _vm.$set(_vm.attachForm, "ignoreProcess", $$v)
                              },
                              expression: "attachForm.ignoreProcess",
                            },
                          },
                          [_vm._v(" Ignore ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "is-primary" },
                            on: { click: _vm.copyFormClipBoard },
                          },
                          [_vm._v(" Copy from clipboard ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: _vm.$t("pages.loads.document") } },
                      [
                        !_vm.attachForm.fileField
                          ? _c(
                              "b-upload",
                              {
                                attrs: {
                                  accept:
                                    ".txt, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                                  "drag-drop": "",
                                  required: "",
                                },
                                on: { input: _vm.processFile },
                                model: {
                                  value: _vm.attachForm.fileField,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.attachForm, "fileField", $$v)
                                  },
                                  expression: "attachForm.fileField",
                                },
                              },
                              [
                                _c("section", { staticClass: "section" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "content has-text-centered",
                                    },
                                    [
                                      _c(
                                        "p",
                                        [
                                          _c("b-icon", {
                                            attrs: {
                                              icon: "file-csv",
                                              size: "is-large",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "pages.loads.drop_file_here"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "div",
                              [
                                _c("b-field", [
                                  _vm.attachForm.fileField
                                    ? _c(
                                        "span",
                                        { staticClass: "tag is-info" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.attachForm.fileField.name
                                              ) +
                                              " "
                                          ),
                                          _c("button", {
                                            staticClass: "delete is-small",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                _vm.attachForm.fileField = null
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c(
                                  "b-table",
                                  {
                                    attrs: {
                                      data: _vm.attachForm.fileData,
                                      "per-page": 5,
                                      narrowed: "",
                                      striped: "",
                                      paginated: "",
                                    },
                                  },
                                  [
                                    _c("b-table-column", {
                                      attrs: { label: "Barcode" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (props) {
                                            return [
                                              _vm._v(
                                                " " + _vm._s(props.row) + " "
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _c("template", { slot: "bottom-left" }, [
                                      _c("b", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("global.total")) +
                                            " "
                                        ),
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.attachForm.fileData.length
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c(
                                      "template",
                                      { slot: "empty" },
                                      [_c("nothing-here")],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "footer",
                { staticClass: "modal-card-foot" },
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "is-primary",
                            "native-type": "submit",
                            "icon-left": "file-upload",
                            form: "attachForm",
                            loading: _vm.attachForm.isSubmitting,
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isAttachByQtyModalActive,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isAttachByQtyModalActive = $event
            },
          },
        },
        [
          _c("AttachModal", {
            attrs: {
              shipment: _vm.selectedShipment,
              "max-datetime": _vm.maxDatetime,
              "min-datetime": _vm.minDatetime,
            },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }